module.exports = __webpack_public_path__ + "img/star7.be24af51.png";